module.exports = __webpack_public_path__ + "img/ring_g_s_1_1@3x.92445ef4.png";